import Find from "pages/FindSection"
import Register from "pages/Sales/Register"
import OpeningBalance from "pages/Accounts/Transaction/OpeningBalance"
import Journal from "pages/Finance/Journal"
import GeneralEntry from "pages/Finance/Transaction/GeneralEntry"
import Dashboard from "pages/Sales/Dashboard"
import CustomerOrder from "pages/Sales/Transaction/CustomerOrder"
import CustomerOrderEdit from "pages/Sales/Transaction/CustomerOrder/Edit"
import Invoice from "pages/Sales/Transaction/Invoice"
import InvoiceEdit from "pages/Sales/Transaction/Invoice/Edit"
import ApprovalSO from "pages/Sales/Transaction/ApprovalSO"
import SalesOrderRegisterInvoice from "pages/Sales/Transaction/SalesOrderRegisterInvoice"
import ApproveInvoice from "pages/Sales/Transaction/ApproveInvoice"
import PaymentDeposit from "pages/Sales/Transaction/PaymentDeposit"
import ApprovalDepoCustomer from "pages/Sales/Transaction/ApprovalDepoCustomer"
import PaymentInvoice from "pages/Sales/Transaction/PaymentInvoice"
import PaymentDepositEdit from "pages/Sales/Transaction/PaymentDeposit/Edit"
import ReturnItems from "pages/Sales/Transaction/ReturnItems"
import ApproveReturnItems from "pages/Sales/Transaction/ApproveReturnItems"
import ReturnItemsEdit from "pages/Sales/Transaction/ReturnItems/Edit"
import PaymentInvoiceEdit from "pages/Sales/Transaction/PaymentInvoice/Edit"
import ReturnRecord from "pages/Sales/Transaction/ReturnRecord"
import EditReturnRecord from "pages/Sales/Transaction/ReturnRecord/Edit"
import RefundReturnItem from "pages/Sales/Transaction/RefundReturnItem"
import RefundReturnMoney from "pages/Sales/Transaction/RefundReturnMoney"
import RefundReturnAdjustment from "pages/Sales/Transaction/RefundReturnAdjustment"
import ListInvoiceAdjustment from "pages/Sales/Transaction/AdjustmentFreightInvoice/ListInvoiceAdjustment"
import CreateInvoiceAdjustment from "pages/Sales/Transaction/AdjustmentFreightInvoice/CreateInvoiceAdjustment"
import type { RouteType } from "types"
import ApprovePaymentInvoice from "pages/Sales/Transaction/ApprovePaymentInvoice"
import CustomerQuotation from "pages/Sales/Transaction/CustomerQuotation"
import CustomerQuotationEdit from "pages/Sales/Transaction/CustomerQuotation/Edit"
import ApproveQuotation from "pages/Sales/Transaction/ApproveQoutation"
import CloseSalesOrder from "pages/Sales/Transaction/CloseSalesOrder"
import ApproveReturnRefund from "pages/Sales/Transaction/ApproveReturnRefund"
import ListAnalyse from "pages/Sales/Report/AnalyseSalesPeriode/ListAnalyse"
import AnalyseSalesComparation from "pages/Sales/Report/AnalyseSalesComparation"
import { PERMISION } from "security"

export const salesRoutes: RouteType[] = [
  {
    path: "/sales/register",
    element: <Register />,
    permission: PERMISION.SALES.REGISTER.PERMISION
  },
  {
    path: "/sales/transaction/customer-order",
    element: <CustomerOrder />,
    permission: PERMISION.SALES.TRANSACTION.CUSTOMER_ORDER.CREATE
  },
  {
    path: "/sales/transaction/customer-order/edit/:sales_order_id",
    element: <CustomerOrderEdit />,
    permission: 
      PERMISION.SALES.REGISTER.BY_DATE_RANGE.UPDATE || 
      PERMISION.SALES.REGISTER.BY_CARD.UPDATE || 
      PERMISION.SALES.REGISTER.BY_LOCATION.UPDATE ||
      PERMISION.SALES.REGISTER.BY_REFERENCE_ID.UPDATE
  },
  {
    path: "/sales/transaction/close-sales/:sales_order_id",
    element: <CloseSalesOrder />,
    permission: "ST023"
  },
  {
    path: "/sales/report/dashboard",
    element: <Dashboard />,
    permission: PERMISION.SALES.REPORT.DASHBOARD.READ
  },
  {
    path: "/sales/transaction/opening-balance",
    element: <OpeningBalance />,
    permission: "AT01"
  },
  {
    path: "/sales/journal",
    element: <Journal />,
    permission: PERMISION.SALES.JOURNAL.PERMISION
  },
  {
    path: "/sales/find",
    element: <Find />,
    permission: PERMISION.SALES.FIND.PERMISION
  },
  {
    path: "/sales/transaction/general-entry",
    element: <GeneralEntry />,
    permission: "AT02"
  },
  {
    path: "/sales/transaction/sales-order-register",
    element: <SalesOrderRegisterInvoice />,
    permission: "ST09"
  },
  {
    path: "/sales/transaction/approve-so",
    element: <ApprovalSO />,
    permission: PERMISION.SALES.TRANSACTION.CUSTOMER_ORDER_APPROVAL.READ
  },
  {
    path: "/sales/transaction/approve-invoice",
    element: <ApproveInvoice />,
    permission: PERMISION.SALES.TRANSACTION.INVOICE_APPROVAL.READ
  },
  {
    path: "/sales/transaction/invoice/:sales_order_id",
    element: <Invoice />,
    permission: "ST12"
  },
  {
    path: "/sales/transaction/invoice/edit/:invoice_id",
    element: <InvoiceEdit />,
    permission: PERMISION.SALES.REGISTER.ALL_INVOICE.UPDATE || PERMISION.SALES.REGISTER.AGED_RECEIVABLE.UPDATE
  },
  {
    path: "/sales/transaction/approve-depo-customer",
    element: <ApprovalDepoCustomer />,
    permission: PERMISION.SALES.TRANSACTION.CUSTOMER_DEPOSIT_APPROVAL.READ
  },
  {
    path: "/sales/transaction/payment-invoice/:invoice_id",
    element: <PaymentInvoice />,
    permission: "ST14"
  },
  {
    path: "/sales/transaction/payment-invoice/edit/:payment_invoice_id",
    element: <PaymentInvoiceEdit />,
    permission: "ST14"
  },
  {
    path: "/sales/transaction/approve-payment-invoice",
    element: <ApprovePaymentInvoice />,
    permission: PERMISION.SALES.TRANSACTION.PAYMENT_INVOICE_APPROVAL.READ
  },
  {
    path: "/sales/transaction/payment-deposit/:sales_order_id",
    element: <PaymentDeposit />,
    permission: "ST16"
  },
  {
    path: "/sales/transaction/payment-deposit/edit/:deposit_customer_id",
    element: <PaymentDepositEdit />,
    permission: "ST16"
  },
  {
    path: "/sales/transaction/return-items/:invoice_id",
    element: <ReturnItems />,
    permission: "ST17"
  },
  {
    path: "/sales/transaction/return-items/edit/:return_id",
    element: <ReturnItemsEdit />,
    permission: "ST17"
  },
  {
    path: "/sales/transaction/approve-return-items",
    element: <ApproveReturnItems />,
    permission: PERMISION.SALES.TRANSACTION.RETURN_ITEMS_APPROVAL.READ
  },
  {
    path: "/sales/transaction/approve-quotation",
    element: <ApproveQuotation />,
    permission: PERMISION.SALES.TRANSACTION.CUSTOMER_QUOTATION_APPROVAL.READ
  },
  {
    path: "/sales/transaction/customer-quotation",
    element: <CustomerQuotation />,
    permission: PERMISION.SALES.TRANSACTION.CUSTOMER_QUOTATION.CREATE
  },
  {
    path: "/sales/transaction/customer-quotation/edit/:customer_quotation_id",
    element: <CustomerQuotationEdit />,
    permission: PERMISION.SALES.REGISTER.QUOTATION.UPDATE
  },
  {
    path: "/sales/transaction/return-record",
    element: <ReturnRecord />,
    permission: PERMISION.SALES.TRANSACTION.CREATE_RETURNED_RECORD.READ
  },
  {
    path: "/sales/transaction/return-record/:id",
    element: <EditReturnRecord />,
    permission: PERMISION.SALES.TRANSACTION.CREATE_RETURNED_RECORD.UPDATE
  },
  {
    path: "/sales/transaction/refund-return-item/:id",
    element: <RefundReturnItem />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/transaction/refund-return-money/:id",
    element: <RefundReturnMoney />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/transaction/refund-return-adjustment/:id",
    element: <RefundReturnAdjustment />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/transaction/approve-return-refund",
    element: <ApproveReturnRefund />,
    permission: PERMISION.SALES.TRANSACTION.REFUND_RETURN_APPROVAL.READ
  },

  {
    path: "/sales/transaction/adjustment-freight/list",
    element: <ListInvoiceAdjustment />,
    permission: PERMISION.SALES.TRANSACTION.ADJUSTMENT_FREIGHT_INVOICE.READ
  },

  {
    path: "/sales/transaction/adjustment-freight/:id",
    element: <CreateInvoiceAdjustment />,
    permission: PERMISION.SALES.TRANSACTION.ADJUSTMENT_FREIGHT_INVOICE.UPDATE
  },

  {
    path: "/sales/report/aging-summary",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/ageng-detail",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/sales-summary",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/analyse-sales-periode",
    element: <ListAnalyse/>,
    permission: PERMISION.SALES.REPORT.ANALYSE_SALES_PERIODE.READ
  },
  {
    path: "/sales/report/analyse-sales-comparation",
    element: <AnalyseSalesComparation/>,
    permission: PERMISION.SALES.REPORT.ANALYSE_SALES_COMPARATION.READ
  },
  {
    path: "/sales/report/analyse-sales-comparation",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/analyse-sales-monthly",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/customer-sales-detail",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/salesperson-sales-summary",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/salesperson-sales-detail",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/all-sales",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/payment-history",
    element: <div />,
    permission: "ST" // BELUM
  },
  {
    path: "/sales/report/sales-receivable-journal",
    element: <div />,
    permission: "ST" // BELUM
  },
]
